import { useOutletContext } from "react-router-dom";
import AddRoleForm from "../../components/adminDashboard/ui/roles/AddRoleForm";
import RoleTable from "../../components/adminDashboard/ui/roles/RoleTable";

export default function RoleManagement() {
  const {
    isRoleOnboarding,
    setIsRoleOnboarding,
    selectedRoleDetails,
    setSelectedRoleDetails,
  } = useOutletContext();

  const handleEdit = (role) => {
    setSelectedRoleDetails(role);
    setIsRoleOnboarding(true);
  };

  return (
    <div>
      {!isRoleOnboarding ? (
        <RoleTable onEdit={handleEdit} />
      ) : (
        <AddRoleForm
          editData={selectedRoleDetails}
          onBack={() => {
            setIsRoleOnboarding(false);
            setSelectedRoleDetails(null);
          }}
        />
      )}
    </div>
  );

}
